import { useScreenSidebar } from './useSidebar';
import { SidebarContainer, SidebarInnerContainer } from './styled';
export function Sidebar(props) {
    const { children, id } = props;
    const { state } = useScreenSidebar(id);
    return (<SidebarContainer $open={state}>
      <SidebarInnerContainer>{children}</SidebarInnerContainer>
    </SidebarContainer>);
}
